module.exports = __webpack_public_path__ + "static/image_10-f41bfbf7598b5fdf68ad3e412433536a.jpg";